import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { EditCrewMemberDatesModalComponent } from 'src/app/crew-management-user/modals/edit-crew-member-dates-modal/edit-crew-member-dates-modal.component';
import { IPlannedActivityFromBasicTrip } from 'src/app/crew-management-user/models/planned-activities/planned-activity.model';
import { DeleteCrewMemberFromTrip } from 'src/app/crew-management-user/state/trips/trip.actions';
import { Privileges } from 'src/app/core/privileges/privileges';

@Component({
  selector: 'app-trip-crew-members-template',
  templateUrl: './trip-crew-members-template.component.html',
  styleUrls: ['./trip-crew-members-template.component.scss'],
  standalone: false,
})
export class TripCrewMembersTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
  availabilityStatus = 'ok';
  availabilityLabel = 'ok';
  Privileges = Privileges;

  constructor(
    private store: Store,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const hasConflicts = this.element?.conflictingActivities?.length > 0;
    this.availabilityStatus = hasConflicts ? 'expiring' : 'ok';
    this.availabilityLabel = hasConflicts
      ? `${this.element?.conflictingActivities?.length} ${this.translate.instant('conflicts')}`
      : this.translate.instant('available');
  }

  editCrewMember(
    crewMember: IPlannedActivityFromBasicTrip & {
      tripId: string;
      splitActivities?: IPlannedActivityFromBasicTrip[];
    }
  ) {
    this.dialog
      .open(EditCrewMemberDatesModalComponent, {
        width: '35rem',
        panelClass: 'mobile-sizing-for-mat-dialogs',
        data: crewMember,
      })
      .afterClosed()
      .subscribe();
  }

  deleteCrewMember(
    crewMember: IPlannedActivityFromBasicTrip & {
      tripId: string;
      splitActivities: IPlannedActivityFromBasicTrip[];
    }
  ) {
    this.store.dispatch(new DeleteCrewMemberFromTrip(crewMember.tripId, [crewMember.userId]));
  }
}
